import React, { useRef, useEffect } from 'react';
import { useNotification } from '../../contexts/NotificationContext';
import ToastContainer from './ToastContainer';

const NotificationContainer = () => {
  const toastContainerRef = useRef();
  const { notifications } = useNotification();
  const lastNotificationId = useRef(null);

  useEffect(() => {
    if (!toastContainerRef.current || notifications.length === 0) return;

    const lastNotif = notifications[0];

    // Only show toast for new unread notifications
    if (lastNotif && lastNotif.id !== lastNotificationId.current && !lastNotif.read) {
      lastNotificationId.current = lastNotif.id;
      toastContainerRef.current.addToast({
        type: lastNotif.type,
        title: lastNotif.title,
        message: lastNotif.message,
      });
    }
  }, [notifications]);

  return <ToastContainer ref={toastContainerRef} />;
};

export default NotificationContainer;


